"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/list/style");
var _list = _interopRequireDefault(require("antd/lib/list"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _Member = _interopRequireDefault(require("./Member"));
var _utils = require("../../../../utils");
var _AddMember = _interopRequireDefault(require("./AddMember"));
var _MemberSearchableBan = _interopRequireDefault(require("./MemberSearchableBan"));
var _utils2 = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Title = function Title(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium mb-[30px]"
  }, children);
};
var SubTitle = function SubTitle(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-label-medium mb-[20px]"
  }, children);
};
var ManageMembers = function ManageMembers(_ref3) {
  var propChannel = _ref3.channel,
    client = _ref3.client;
  var modal = (0, _utils.useModalState)();
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    latestMembers = _useState2[0],
    setLatestMembers = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedMember = _useState4[0],
    setSelectedMember = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    searchMembers = _useState6[0],
    setSearchMembers = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var onLoadSearchOptions = (0, _react.useCallback)((0, _lodash.debounce)( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(searchValue, setOptions) {
      var _yield$propChannel$qu, members, reactSelectMembers;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!searchValue) {
                _context.next = 8;
                break;
              }
              setLoading(true);
              _context.next = 4;
              return propChannel.queryMembers({
                name: {
                  $autocomplete: searchValue
                }
              });
            case 4:
              _yield$propChannel$qu = _context.sent;
              members = _yield$propChannel$qu.members;
              if (!(0, _lodash.isEmpty)(members)) {
                setSearchMembers(members);
                reactSelectMembers = (0, _utils2.getReactSelectOptionsFromMembers)(members);
                setOptions(reactSelectMembers);
              }
              setLoading(false);
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }(), 700), [loading, searchMembers]);
  var refetchSelectedMember = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(accountId) {
      var _yield$propChannel$qu2, members;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (accountId) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return propChannel.queryMembers({
                user_id: accountId
              });
            case 4:
              _yield$propChannel$qu2 = _context2.sent;
              members = _yield$propChannel$qu2.members;
              return _context2.abrupt("return", (0, _lodash.isEmpty)(members) ? undefined : members[0]);
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function refetchSelectedMember(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  var onSearchItemSelect = function onSearchItemSelect(option) {
    var accountId = option === null || option === void 0 ? void 0 : option.value;
    if (!(0, _lodash.isEmpty)(searchMembers) && accountId) {
      var fullSelectedMember = searchMembers.find(function (member) {
        var _member$user;
        return ((_member$user = member.user) === null || _member$user === void 0 ? void 0 : _member$user.id) === accountId;
      });
      if (fullSelectedMember) {
        setSelectedMember(fullSelectedMember);
      }
    }
  };
  var onSelectedMemberBanChange = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _selectedMember$user;
      var userId, updatedMember;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              userId = selectedMember === null || selectedMember === void 0 ? void 0 : (_selectedMember$user = selectedMember.user) === null || _selectedMember$user === void 0 ? void 0 : _selectedMember$user.id;
              if (!userId) {
                _context3.next = 8;
                break;
              }
              setSelectedMember(undefined);
              _context3.next = 5;
              return refetchSelectedMember(userId);
            case 5:
              updatedMember = _context3.sent;
              if (updatedMember) {
                setSelectedMember(updatedMember);
              }
              getLatestChannelMembers();
            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function onSelectedMemberBanChange() {
      return _ref6.apply(this, arguments);
    };
  }();
  var getLatestChannelMembers = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _yield$client$queryCh, _yield$client$queryCh2, channel;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setLoading(true);
              _context4.next = 3;
              return client.queryChannels({
                id: propChannel.id
              }, {}, {
                watch: true,
                state: true
              });
            case 3:
              _yield$client$queryCh = _context4.sent;
              _yield$client$queryCh2 = _slicedToArray(_yield$client$queryCh, 1);
              channel = _yield$client$queryCh2[0];
              // most recently added first
              setLatestMembers((0, _lodash.reverse)((0, _lodash.values)(channel.state.members)));
              setLoading(false);
            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function getLatestChannelMembers() {
      return _ref7.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "info-circle-o",
    onClick: function onClick() {
      modal.show();
      getLatestChannelMembers();
    }
  }), /*#__PURE__*/_react.default.createElement(_modal.default, {
    title: /*#__PURE__*/_react.default.createElement(Title, null, "Manage channel members"),
    visible: modal.visible,
    onCancel: modal.hide,
    footer: null,
    destroyOnClose: true
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-members-management"
  }, /*#__PURE__*/_react.default.createElement(SubTitle, null, "Search for channel member"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_MemberSearchableBan.default, {
    channelId: propChannel.id,
    onLoadOptions: onLoadSearchOptions,
    onSelect: onSearchItemSelect
  })), !(0, _lodash.isEmpty)(selectedMember) && /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-[30px]"
  }, /*#__PURE__*/_react.default.createElement(_Member.default, {
    chatUser: client.user,
    member: selectedMember,
    channelId: propChannel.id,
    onChangeBan: onSelectedMemberBanChange
  })), /*#__PURE__*/_react.default.createElement(SubTitle, null, "Add member"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_AddMember.default, {
    channelId: propChannel.id,
    onAdded: function onAdded() {
      return getLatestChannelMembers();
    }
  })), /*#__PURE__*/_react.default.createElement(SubTitle, null, "Latest added members list (up to 100)"), /*#__PURE__*/_react.default.createElement(_list.default, {
    dataSource: loading ? [] : latestMembers,
    renderItem: function renderItem(member) {
      return /*#__PURE__*/_react.default.createElement(_list.default.Item, null, /*#__PURE__*/_react.default.createElement(_Member.default, {
        chatUser: client.user,
        member: member,
        channelId: propChannel.id,
        onChangeBan: getLatestChannelMembers
      }));
    },
    className: "channel-members__list"
  })))));
};
var _default = ManageMembers;
exports.default = _default;